import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const GroupMasterList = createSlice({
  name: "GroupMasterList",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    data: [],
  },
  reducers: {
    list_group_master: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_list_group_master: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
    },
    failure_api_call_list_group_master: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    group_master_isFirst: (state, action) => {
      state.isFirst = false;
    },
  },
});
export default GroupMasterList.reducer;
export const {
  list_group_master,
  success_api_call_list_group_master,
  failure_api_call_list_group_master,
  group_master_isFirst,
} = GroupMasterList.actions;
